export const GET_MENU_URL = '/users/menus';
export const GET_MENU_HELP_URL = '/menu/getMenuHelp';
